module.exports = __webpack_public_path__ + "static/img-reading-7bd7cb451d9c519f4dd07aaa9e45ec88.svg";